import { useStore } from 'effector-react';
import { $editingTagLine } from '@stores/editingTagLine';

function TagLineTip() {
  const editing = useStore($editingTagLine);

  if (
    editing?.tagLine &&
    editing?.tagLine.startAth === 0 &&
    editing?.tagLine.endAtv === 0
  ) {
    return (
      <div className="absolute flex h-30 items-center rounded bg-orange px-10">
        点击屏幕绘制标尺
      </div>
    );
  }
  return null;
}

export default TagLineTip;
